import { ArrowTopRightIcon, CopyIcon } from '@radix-ui/react-icons';
import { Button } from '@radix-ui/themes';
import { currentUser } from 'helpers/authentication';
import { errorToastMessage, successToastMessage } from 'helpers/toaster';
import { getTweCode, openMembershipSubscriptionManagementPage, openPostSellPageMembership } from 'helpers/utils';
import Container from './Container';

export const PremiumManagementContent: React.FC = () => {
  const user = currentUser();
  const expirationDate = new Date(user?.premium_expiration).toLocaleDateString('it-IT');
  const tweCode = getTweCode(new Date(user?.premium_expiration));

  const postSellLink = (
    <div className='mt-10 flex flex-col gap-3 text-neutral-neutral-8 md:flex-row'>
      <Button
        variant='outline'
        className='cursor-pointer py-5 md:py-2'
        onClick={() => {
          openPostSellPageMembership();
        }}
      >
        Scopri cosa hai incluso nella tua Club Membership
      </Button>
    </div>
  );

  const membershipSubscriptionManagementLink = (
    <div className='mt-10 flex flex-col gap-3 text-neutral-neutral-8'>
      <div className='mb-5'>
        Se hai una membership annuale, qui trovi la pagina di gestione, facendo login inserendo
        <span className='ml-1 underline'>la mail utilizzata per l'acquisto</span>:
      </div>
      <div>
        <Button
          variant='outline'
          className='cursor-pointer'
          onClick={() => {
            openMembershipSubscriptionManagementPage();
          }}
        >
          <span>Pagina di Gestione</span>
        </Button>
      </div>
    </div>
  );

  const infoClassName = 'ml-1 font-bold text-neutral-neutral-10';

  const copyCode = () => {
    navigator.clipboard.writeText(tweCode).then(
      () => {
        successToastMessage('Codice copiato con successo');
      },
      () => {
        errorToastMessage('Errore nel copiare il codice');
      },
    );
  };

  return (
    <Container title='La tua Club Membership' className='bg-neutral-neutral-2'>
      <div className='mt-10 text-neutral-neutral-8'>
        <p>
          Il tuo status è: <span className={infoClassName}>CLUB MEMBER</span>
        </p>
        <p>
          Scadenza Membership: <span className={infoClassName}>{expirationDate}</span>
        </p>
        <p>
          Il tuo codice sconto del <span className={infoClassName}>15%</span> su Tennis Warehouse Europe è:
          <span className={infoClassName}>
            {tweCode}
            <a className='ml-2' onClick={copyCode}>
              <CopyIcon />
            </a>
            <a
              className='ml-2.5'
              href='https://www.tenniswarehouse-europe.com/?from=ttalker'
              rel='noopener noreferrer'
              target='_blank'
            >
              <ArrowTopRightIcon />
            </a>
          </span>
        </p>
      </div>
      {postSellLink}
      {membershipSubscriptionManagementLink}
    </Container>
  );
};

export default PremiumManagementContent;
